import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ArrowSquareOut } from '@phosphor-icons/react';
import { openAmazon } from '../pages/Store';

const API = process.env.REACT_APP_BACKEND_URL;

export const AmazonPicks = () => {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    axios.get(`${API}/api/store/products?limit=4`).then((r) => setProducts((r.data.products || []).slice(0, 4))).catch(() => {});
  }, []);
  if (!products.length) return null;
  return (
    <div className="mt-8 bg-white dark:bg-neutral-800 border-2 border-black rounded-xl p-4 shadow-[4px_4px_0px_#000]" data-testid="amazon-picks-panel">
      <div className="flex items-center justify-between mb-3">
        <p className="font-black uppercase text-sm text-neutral-900 dark:text-white">🛒 New on Amazon — Pro Picks</p>
        <Link to="/store" className="text-xs font-black uppercase text-[#D95800] underline" data-testid="amazon-picks-see-all">See all</Link>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {products.map((p) => (
          <button key={p.id} onClick={() => openAmazon(p.id)} className="group text-left border border-neutral-200 dark:border-neutral-700 rounded-lg p-2 hover:border-[#D95800] transition-colors" data-testid={`amazon-pick-${p.id}`}>
            <div className="aspect-square bg-white rounded flex items-center justify-center p-1 mb-1.5">
              <img src={p.image_url} alt={p.title} loading="lazy" className="max-h-full max-w-full object-contain"
                onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = '/store-placeholder.jpg'; }} />
            </div>
            <p className="text-xs font-bold text-neutral-800 dark:text-neutral-200 line-clamp-2 leading-snug">{p.title}</p>
            <p className="text-xs font-black text-[#D95800] mt-0.5 flex items-center gap-1">{p.price_display} <ArrowSquareOut size={10} weight="bold" className="text-neutral-400 group-hover:text-[#D95800]" /></p>
          </button>
        ))}
      </div>
      <p className="text-[10px] text-neutral-400 mt-2">As an Amazon Associate we earn from qualifying purchases.</p>
    </div>
  );
};
